import { render, staticRenderFns } from "./GetClassType.vue?vue&type=template&id=5f3a71e8&"
import script from "./GetClassType.vue?vue&type=script&lang=js&"
export * from "./GetClassType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports